import CES from "./KrCes.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrCes = install(CES); // 生成带有 install 方法的组件

export default KrCes;
